import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Error';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import { globalStyles } from './style/gstheme';

const styles = () => {
  return Object.assign({
    actions: {
      width: '100%',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between'
    }
  }, globalStyles);
};

class Errored extends React.Component {

  exitError = () => {
    if (this.props.fatal) {
      // We ignore outstanding edits if it is fatal
      if (this.props.logOut) this.props.logOut(true);
    }
    else if (this.props.clearError) {
      this.props.clearError();
    }
    else {
      this.props.history.push("/");
    }
  };

  render() {

    const { classes, dataTest, hideFatal } = this.props;
    const unsplitMessage = this.props.data.message;
    const message = Array.isArray(unsplitMessage) ? unsplitMessage : unsplitMessage.split("\n");
    const date = new Date(Date.now());
    let isoDate = date.toISOString();

    return (
      <React.Fragment>
        <Dialog data-test={dataTest || "problem"} open={true} onClose={this.exitError} aria-labelledby="error-dialog-title" >
          <DialogTitle
            disableTypography
            className={classes.mainHeading}
            id="error-dialog-title">{
              this.props.fatal ?
                "Something Went Wrong"
                :
                "A Problem Has Occurred"
            } <ErrorIcon style={{ float: 'right', marginLeft: 20 }} fontSize="large" />
          </DialogTitle>
          <DialogContent>
            {Array.isArray(message) ?
              message.map((line, index) =>
                <DialogContentText
                  key={index}
                  className={classes.dialogText}
                  paragraph>
                  <span data-test={"error-line-" + index} style={{ display: 'block' }}>{line}</span>
                </DialogContentText>
              )
              :
              <DialogContentText data-test={"error-line"} className={classes.dialogText} paragraph>{
                message
              }
              </DialogContentText>
            }
            {this.props.fatal && !hideFatal &&
              <React.Fragment>
                <DialogContentText paragraph className={classes.dialogText}>Please contact support at support@graphifi.com and give details about this problem.</DialogContentText>
                <DialogContentText paragraph className={classes.dialogText}>Unfortunately you need to be logged out of the application.</DialogContentText>
              </React.Fragment>
            }
          </DialogContent>
          {this.props.actionable &&
            <DialogActions className={classes.dialogActions}>
              <div className={classes.actions}>
                <div style={{ marginRight: 20 }}>
                  <DialogContentText data-test="error-date" paragraph className={classes.smallDialogText}>Date reference: {isoDate}</DialogContentText>
                </div>
                <PrimaryButton onClick={this.exitError}>Close</PrimaryButton>
              </div>
            </DialogActions>
          }
        </Dialog>
      </React.Fragment>
    );
  }
}

Errored.defaultProps = {
  fatal: false,
  actionable: true,
  hideFatal: false
};

Errored.propTypes = {
  dataTest: PropTypes.string,
  data: PropTypes.object,
  hideFatal: PropTypes.bool,
  history: PropTypes.object,
  fatal: PropTypes.bool,
  actionable: PropTypes.bool,
  logOut: PropTypes.func,
  clearError: PropTypes.func,
  classes: PropTypes.object
};

export default withRouter(withStyles(styles)(Errored));